import ProductCardZone from 'components/Catalog/ProductGrid/CompareModal/Zones/ProductCardZone/ProductCardZone';

export default ProductCardZone;
